import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import React, { ReactNode, useCallback, useContext, useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import styles from "./Header.module.scss";
import { GeneralBanner } from "../GeneralBanner/GeneralBanner";
import { GeneralBannerQueryResult } from "../../../../studio/sanity.types";
import { BannerContext } from "../../../main/layout/layout";
export const MainHeader: React.FC<{
  children: ReactNode | ReactNode[];
  hideOnScroll: boolean;
  generalBannerConfig?: GeneralBannerQueryResult;
  alwaysShrink?: boolean;
}> = t0 => {
  const $ = _c(39);
  const {
    children,
    hideOnScroll,
    generalBannerConfig,
    alwaysShrink
  } = t0;
  const router = useRouter();
  const [bannerContext] = useContext(BannerContext);
  const [navbarShrinked, setNavbarShrinked] = useState(alwaysShrink ?? false);
  const [navBarVisible, setNavBarVisible] = useState(true);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);
  let t1;
  if ($[0] !== alwaysShrink) {
    t1 = () => {
      if (typeof window !== "undefined" && !alwaysShrink) {
        if (window.scrollY > 0) {
          setNavbarShrinked(true);
        } else {
          setNavbarShrinked(false);
        }
      }
    };
    $[0] = alwaysShrink;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const navBarCheck = t1;
  let t2;
  if ($[2] !== lastScrollPosition) {
    t2 = () => {
      if (typeof window !== "undefined") {
        if (window.scrollY > lastScrollPosition && window.scrollY > 160) {
          setNavBarVisible(false);
        } else {
          if (window.scrollY < lastScrollPosition - 300 || window.scrollY <= 160) {
            setNavBarVisible(true);
          }
        }
      }
    };
    $[2] = lastScrollPosition;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const navBarVisibleCheck = t2;
  let t3;
  if ($[4] !== hideOnScroll || $[5] !== navBarCheck || $[6] !== navBarVisibleCheck) {
    t3 = () => {
      navBarCheck();
      if (hideOnScroll) {
        navBarVisibleCheck();
      }
      setLastScrollPosition(window.scrollY);
    };
    $[4] = hideOnScroll;
    $[5] = navBarCheck;
    $[6] = navBarVisibleCheck;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      maxWait: 250
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const debounced = useDebouncedCallback(t3, 250, t4);
  let t5;
  if ($[9] !== navBarCheck || $[10] !== router.query.sluq) {
    t5 = [router.query.sluq, navBarCheck];
    $[9] = navBarCheck;
    $[10] = router.query.sluq;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  useEffect(navBarCheck, t5);
  let t6;
  if ($[12] !== debounced) {
    t6 = () => {
      if (typeof window !== "undefined") {
        window.addEventListener("scroll", debounced);
      }
    };
    $[12] = debounced;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t6);
  let containerClasses;
  if ($[14] !== navbarShrinked) {
    containerClasses = [styles.container];
    if (navbarShrinked) {
      containerClasses.push(styles.navbarShrinked);
    }
    $[14] = navbarShrinked;
    $[15] = containerClasses;
  } else {
    containerClasses = $[15];
  }
  let headerStackClasses;
  if ($[16] !== navBarVisible) {
    headerStackClasses = [styles.headerStack];
    if (!navBarVisible) {
      headerStackClasses.push(styles.headerHidden);
    }
    $[16] = navBarVisible;
    $[17] = headerStackClasses;
  } else {
    headerStackClasses = $[17];
  }
  const showGeneralBanner = Boolean(generalBannerConfig) && !bannerContext.generalBannerDismissed;
  let spacerClasses;
  let wrapperClasses;
  if ($[18] !== showGeneralBanner) {
    wrapperClasses = [styles.wrapper];
    if (showGeneralBanner) {
      wrapperClasses.push(styles.hasGeneralBanner);
    }
    spacerClasses = [styles.spacer];
    if (showGeneralBanner) {
      spacerClasses.push(styles.hasGeneralBanner);
    }
    $[18] = showGeneralBanner;
    $[19] = spacerClasses;
    $[20] = wrapperClasses;
  } else {
    spacerClasses = $[19];
    wrapperClasses = $[20];
  }
  const t7 = wrapperClasses.join(" ");
  const t8 = spacerClasses.join(" ");
  let t9;
  if ($[21] !== t8) {
    t9 = <div aria-hidden="true" className={t8} />;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const t10 = containerClasses.join(" ");
  const t11 = headerStackClasses.join(" ");
  let t12;
  if ($[23] !== generalBannerConfig || $[24] !== showGeneralBanner) {
    t12 = showGeneralBanner && generalBannerConfig && <GeneralBanner configuration={generalBannerConfig} />;
    $[23] = generalBannerConfig;
    $[24] = showGeneralBanner;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== children) {
    t13 = <div data-cy="header-navbar" className={styles.navbarWrapper}>{children}</div>;
    $[26] = children;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t11 || $[29] !== t12 || $[30] !== t13) {
    t14 = <div className={t11}>{t12}{t13}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t10 || $[33] !== t14) {
    t15 = <div data-cy="header" className={t10}>{t14}</div>;
    $[32] = t10;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t15 || $[36] !== t7 || $[37] !== t9) {
    t16 = <div className={t7}>{t9}{t15}</div>;
    $[35] = t15;
    $[36] = t7;
    $[37] = t9;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};